import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const VerifiedTick = (props) => (
    <svg
        fill='none'
        height='25'
        viewBox='0 0 25 25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M10.0864 1.86383C10.9552 0.378533 13.1024 0.378531 13.9712 1.86383L14.1323 2.1402C14.3397 2.49475 14.7939 2.6167 15.1509 2.41364L15.4292 2.25446C16.9242 1.40259 18.7837 2.47617 18.7935 4.19684L18.7954 4.51715C18.7979 4.92787 19.1298 5.25982 19.5405 5.26227L19.8608 5.26422C21.5815 5.274 22.6551 7.13345 21.8032 8.62848L21.644 8.9068C21.441 9.26375 21.5629 9.71799 21.9175 9.92535L22.1938 10.0865C23.6791 10.9553 23.6791 13.1025 22.1938 13.9713L21.9175 14.1324C21.5629 14.3397 21.441 14.794 21.644 15.1509L21.8032 15.4293C22.6551 16.9243 21.5815 18.7837 19.8608 18.7935L19.5405 18.7955C19.1298 18.7979 18.7979 19.1299 18.7954 19.5406L18.7935 19.8609C18.7837 21.5816 16.9242 22.6551 15.4292 21.8033L15.1509 21.6441C14.7939 21.441 14.3397 21.563 14.1323 21.9175L13.9712 22.1939C13.1024 23.6792 10.9552 23.6792 10.0864 22.1939L9.92529 21.9175C9.71793 21.563 9.26369 21.441 8.90674 21.6441L8.62842 21.8033C7.13339 22.6551 5.27394 21.5816 5.26416 19.8609L5.26221 19.5406C5.25976 19.1299 4.9278 18.7979 4.51709 18.7955L4.19678 18.7935C2.47611 18.7837 1.40253 16.9243 2.25439 15.4293L2.41357 15.1509C2.61664 14.794 2.49469 14.3397 2.14014 14.1324L1.86377 13.9713C0.378472 13.1025 0.37847 10.9553 1.86377 10.0865L2.14014 9.92535C2.49469 9.71799 2.61664 9.26374 2.41357 8.9068L2.25439 8.62848C1.40253 7.13345 2.47611 5.274 4.19678 5.26422L4.51709 5.26227C4.9278 5.25982 5.25976 4.92786 5.26221 4.51715L5.26416 4.19684C5.27394 2.47617 7.13339 1.40259 8.62842 2.25446L8.90674 2.41364C9.26368 2.6167 9.71793 2.49475 9.92529 2.1402L10.0864 1.86383Z'
            fill='#FC5200'
            stroke='white'
            strokeWidth='1.5'/>
        <path
            d='M17.6538 9.22969L10.4037 16.4809L6.40381 12.481L7.72963 11.1552L10.4037 13.8292L16.328 7.90387L17.6538 9.22969Z'
            fill='white'/>
    </svg>
);

export default VerifiedTick;
